/**
 * Snippets API
 * Here is the API DNA
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface FolderSerializerPartialUpdate {
  name?: string;
  number?: string;
  category?: FolderSerializerPartialUpdate.CategoryEnum;
  dateSignature?: string;
  dateComp?: string;
  region?: FolderSerializerPartialUpdate.RegionEnum;
  propertyTypes?: Array<string>;
  collaborator?: string;
}
export namespace FolderSerializerPartialUpdate {
  export type CategoryEnum = 'IMMO';
  export const CategoryEnum = {
    IMMO: 'IMMO' as CategoryEnum,
  };
  export type RegionEnum = 'WALLONIE' | 'FLANDRES' | 'BXL';
  export const RegionEnum = {
    WALLONIE: 'WALLONIE' as RegionEnum,
    FLANDRES: 'FLANDRES' as RegionEnum,
    BXL: 'BXL' as RegionEnum,
  };
}
